import React from "react";
import PropTypes from "prop-types";
import BlanketBasicInformationBase from "../../../../features/bonds/blanket/components/BlanketBasicInformationBase";
import { BLANKET_BASIC_INFO_CONFIG } from "../../../../features/bonds/blanket/components/blanketBasicInformationConfig";
import BlanketHistoricGoogleAutoComplete from "./BlanketHistoricGoogleAutoComplete";

const BlanketHistoricBasicInformation = (props) => (
  <BlanketBasicInformationBase
    config={{
      ...BLANKET_BASIC_INFO_CONFIG.historic,
      GoogleAutoCompleteComponent: BlanketHistoricGoogleAutoComplete,
    }}
    {...props}
  />
);

BlanketHistoricBasicInformation.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired,
  allCounties: PropTypes.array,
  loadingCounties: PropTypes.bool,
  residencyStatus: PropTypes.any,
  otherResidency: PropTypes.any,
  handleOtherResidencyChange: PropTypes.func.isRequired,
  allCities: PropTypes.array,
  allStates: PropTypes.array,
  emailExists: PropTypes.any,
  emailChecking: PropTypes.any,
  emailDialogOpen: PropTypes.any,
  emailDebounceRef: PropTypes.object,
  handleDialogClose: PropTypes.func.isRequired,
  handleDialogContinue: PropTypes.func.isRequired,
  handleDialogCancel: PropTypes.func.isRequired,
  professionalGuardians: PropTypes.array,
  loadingGuardians: PropTypes.bool,
  formatSSN: PropTypes.func.isRequired,
  handleGoogleCallback: PropTypes.func.isRequired,
};

export default BlanketHistoricBasicInformation;
